var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { redirectToPage, getHashOrPath, createDomElement } from "../../helpers";
import { API_METHODS_ENUM, getAPI } from "../../httpService";
import { ERoute } from "../../helpers/Routes";
import { getResponseManager, ResponseTypeEnum } from "../../responseManager/BeeResponseManager";
import { sendFieldValidationErrors, sendFlashNotification, setLoggedIn } from "../actions";
import get from "lodash/get";
import keys from "lodash/keys";
import omitBy from "lodash/omitBy";
import qs from "querystring";
import { batch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getFallbackMessage, getIntegrationURL } from "../stateGetter";
import { mockupCancel } from "../../cancelTokens";
import { getPaginatedRecordsPath } from "../reducers/response.reducer";
export var START_LOADING = Symbol("START_LOADING");
export var LOADING_SUCCESSFUL = Symbol("LOADING_SUCCESSFUL");
export var LOADING_FAILED = Symbol("LOADING_FAILED");
export var SET_QUERY_STRING = Symbol("SET_QUERY_STRING");
export var SET_REQUEST_QUERY_STRING = Symbol("SET_REQUEST_QUERY_STRING");
export var RESET_API_RESPONSE = Symbol("RESET_API_RESPONSE");
export var setRequestQueryString = function (name, queryString, pageNumber) { return ({
    type: SET_REQUEST_QUERY_STRING,
    name: name,
    queryString: queryString,
    pageNumber: pageNumber
}); };
var startLoading = function (name, _a) {
    var _b = _a.resetResponse, resetResponse = _b === void 0 ? true : _b, pageNumber = _a.pageNumber;
    return ({
        type: START_LOADING,
        resetResponse: resetResponse,
        pageNumber: pageNumber,
        name: name,
    });
};
var loadingSuccess = function (name, _a) {
    var response = _a.response, pageNumber = _a.pageNumber, resetAllPages = _a.resetAllPages, rest = __rest(_a, ["response", "pageNumber", "resetAllPages"]);
    return (__assign({ type: LOADING_SUCCESSFUL, name: name,
        pageNumber: pageNumber, resetAllPages: !!pageNumber && resetAllPages, response: response }, rest));
};
var loadingFailed = function (name, resetResponse, error, pageNumber) {
    if (resetResponse === void 0) { resetResponse = true; }
    return ({
        type: LOADING_FAILED,
        resetResponse: resetResponse,
        name: name,
        pageNumber: pageNumber,
        error: error
    });
};
var setQueryString = function (name, queryString, pageNumber) { return ({
    type: SET_QUERY_STRING,
    name: name,
    pageNumber: pageNumber,
    queryString: queryString
}); };
var resetApiResponse = function (name) { return ({
    type: RESET_API_RESPONSE,
    name: name,
}); };
var runAHookSafely = function (type) {
    var _a, _b;
    var hooks = {
        boooking_success: "onBookingSuccess",
        payment_approved: "onBookingSuccess",
        boooking_requires_payment: "onPaymentRequired",
    };
    try {
        (_b = (_a = get(window, "websail")) === null || _a === void 0 ? void 0 : _a[hooks[type]]) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    catch (e) {
        console.log(e);
    }
};
var handleResponse = function (dispatch, getState, response) {
    var fallbackRoute = "";
    var state = getState();
    var stripUrlPath = get(state, "appReducer.stripUrlPath");
    var integrationUrl = getIntegrationURL(state);
    var rm = getResponseManager(response);
    var flashNotifications = rm.flashNotifications();
    if (keys(flashNotifications).length) {
        setTimeout(function () { return dispatch(sendFlashNotification(flashNotifications)); }, 100);
    }
    ;
    switch (rm.name) {
        case "unhandled_exception": {
            return;
        }
        case "boooking_success":
        case "payment_approved":
        case "consents_saved":
            fallbackRoute = getHashOrPath(ERoute.SUCCESS);
            break;
        case "boooking_requires_payment":
        case "pay_bills":
            fallbackRoute = getHashOrPath(ERoute.PAYBOOK);
            break;
        case "unauthenticated":
            dispatch(setLoggedIn(false));
            break;
        case "refresh_token_failed":
            dispatch(setLoggedIn(false));
        case "auth_token_failed":
            throw new Error(rm.name);
    }
    runAHookSafely(rm.name);
    var redirectURL = rm.redirectUrl() || fallbackRoute;
    var fieldValidationErrors = rm.fieldValidationErrors();
    dispatch(sendFieldValidationErrors(fieldValidationErrors));
    redirectToPage(redirectURL, { stripUrlPath: stripUrlPath, integrationUrl: integrationUrl });
    var downloadURL = rm.download();
    if (downloadURL) {
        var downloadNode = createDomElement({
            id: "download-file",
            el: "a",
            html: "",
            href: downloadURL,
            download: "",
            target: "_self"
        });
        document.body.append(downloadNode);
        downloadNode.click();
        document.body.removeChild(downloadNode);
    }
};
var handleError = function (dispatch, getState) {
    var rm = getResponseManager(getState().responseReducer.getInitialData || {});
    var message = rm.getResponseData(ResponseTypeEnum.FALLBACK_ERROR_MESSAGE) || getFallbackMessage(getState());
    dispatch(sendFlashNotification([{ message: message, level: "danger", id: "api-error" }]));
};
var cancelled_api_call = "CANCEL_CALL";
var makeApiCall = function (cancelToken, methodName) {
    if (cancelToken === void 0) { cancelToken = mockupCancel; }
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var integrationName, endpoint, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    integrationName = get(getState(), "appReducer.integrationName");
                    cancelToken.cancel(cancelled_api_call);
                    endpoint = getAPI(integrationName, methodName, cancelToken);
                    return [4 /*yield*/, endpoint.apply(void 0, args)];
                case 1:
                    res = _a.sent();
                    // cancelToken.reset();
                    return [2 /*return*/, res];
            }
        });
    }); };
};
export var deriveMethodName = function (method, options) {
    if (options === void 0) { options = {}; }
    var params = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        params[_i - 2] = arguments[_i];
    }
    var cacheParams = (options !== null && options !== void 0 ? options : {}).cacheParams;
    return cacheParams ? method + JSON.stringify(params) : method;
};
var callAPI = function (arg, methodName) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var _a = arg.cancelToken, cancelToken = _a === void 0 ? mockupCancel : _a, _b = arg.resetResponse, resetResponse = _b === void 0 ? true : _b, _c = arg.cacheParams, cacheParams = _c === void 0 ? false : _c, pageNumber = arg.pageNumber, resetAllPages = arg.resetAllPages, onSuccess = arg.onSuccess;
    return (function (dispatch, getState) {
        var methodKey = deriveMethodName.apply(void 0, __spreadArray([methodName, { cacheParams: cacheParams }], args));
        dispatch(startLoading(methodKey, { resetResponse: resetResponse, pageNumber: pageNumber }));
        return dispatch(makeApiCall.apply(void 0, __spreadArray([cancelToken, methodName], args)))
            .then(function (response) {
            var result = response;
            batch(function () {
                var _a;
                if (result.clearNotifications)
                    dispatch(sendFlashNotification([]));
                var data = result.data;
                dispatch(loadingSuccess(methodKey, __assign({ response: data, resetAllPages: resetAllPages,
                    pageNumber: pageNumber }, ((_a = onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess()) !== null && _a !== void 0 ? _a : {}))));
                handleResponse(dispatch, getState, data);
            });
            return response;
        }).catch(function (error) {
            if ([cancelled_api_call, "auth_token_failed", "refresh_token_failed"]
                .includes(error.message))
                return;
            batch(function () {
                dispatch(loadingFailed(methodKey, resetResponse, error, pageNumber));
                handleError(dispatch, getState);
            });
        });
    });
};
export var useRedirectLoader = function (method) {
    var loaderState = useState(false);
    var response = useSelector(function (state) { return get(state, "responseReducer." + method + ".response"); }) || {};
    var rm = getResponseManager(response);
    var redirectURL = rm.redirectUrl() || "";
    var hasExternalRedirect = redirectURL.startsWith("http");
    useEffect(function () {
        loaderState[1](hasExternalRedirect);
    }, [redirectURL.startsWith("http")]);
    return loaderState;
};
export var getBookEntities = function (queryString, _a) {
    var _b = _a === void 0 ? {} : _a, cancelToken = _b.cancelToken, reset = _b.reset, resetAllPages = _b.resetAllPages;
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            result = null;
            batch(function () { return __awaiter(void 0, void 0, void 0, function () {
                var pageNumber;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            pageNumber = +[].concat(qs.parse(queryString).page)[0] || undefined;
                            return [4 /*yield*/, dispatch(callAPI({
                                    cancelToken: cancelToken,
                                    resetResponse: reset,
                                    resetAllPages: resetAllPages,
                                    pageNumber: pageNumber,
                                    onSuccess: function () { return ({
                                        queryString: queryString
                                    }); }
                                }, API_METHODS_ENUM.GET_BOOK_ENTITIES, queryString))];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/, result];
        });
    }); };
};
export var getInitialEntities = function (cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_INITIAL_ENTITIES); };
export var getCustomerEntities = function (_a, cancelToken) {
    var _b = _a.customerId, customerId = _b === void 0 ? "" : _b, _c = _a.timespanId, timespanId = _c === void 0 ? "" : _c;
    return function (dispatch, getState) {
        // if (query) {
        //     customerId = undefined
        // }
        if (!timespanId && !customerId) {
            return;
        }
        return dispatch(callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_CUSTOMER_ENTITIES, omitBy({ query: customerId, timespan: timespanId }, function (value) { return !value; })));
    };
};
export var getCustomerList = function (_a, cancelToken) {
    var query = _a.query, _b = _a.timespanId, timespanId = _b === void 0 ? "" : _b, customerId = _a.customerId;
    return function (dispatch, getState) {
        // if (query) {
        //     customerId = undefined
        // }
        if (!timespanId) {
            return;
        }
        return dispatch(callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_CUSTOMER_LIST, omitBy({ query: query, timespan: timespanId, customerId: customerId }, function (value) { return !value; })));
    };
};
export var postBookingForm = function (requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_BOOKING_FORM, requestData); };
export var getBankTransferEntities = function (queryObject, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_BANK_TRANSFER_ENTITIES, queryObject); };
export var getPaybookEntities = function (sessionId, reset, couponCode, couponCodeRemoved, cancelToken) {
    if (reset === void 0) { reset = true; }
    return callAPI({ cancelToken: cancelToken, resetResponse: reset }, API_METHODS_ENUM.GET_PAYBOOK_ENTITIES, { sessionId: sessionId, couponCode: couponCode, couponCodeRemoved: couponCodeRemoved });
};
export var postPaybookForm = function (requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_PAYBOOK_FORM, requestData); };
export var getPaymentApproved = function (queryObject, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_PAYMENT_APPROVED, queryObject); };
export var getPaymentCancelled = function (queryObject, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_PAYMENT_CANCELLED, queryObject); };
export var getUserConsentsEntities = function (token, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_USER_CONSENTS, token); };
export var postUserConsentsForm = function (token, requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_USER_CONSENTS, token, requestData); };
export var getSepaDirectDebitEntities = function (payment_session_id, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_SEPA_ENTITIES, payment_session_id); };
export var postSepaDirectDebitForm = function (payment_session_id, requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_SEPA_FORM, payment_session_id, requestData); };
export var getOutgoingMessages = function (queryString, cancelToken) { return function (dispatch, getState) { return dispatch(callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_OUTGOING_MESSAGES, queryString)); }; };
export var getSuccessMessages = function (queryString, cancelToken) { return function (dispatch, getState) { return dispatch(callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_SUCCESS_MESSAGES, queryString)); }; };
export var postUiException = function (error, cancelToken) { return function (dispatch, getState) { return dispatch(makeApiCall(cancelToken, API_METHODS_ENUM.REPORT_EXCEPTION, { store: getState(), error: error })); }; };
export var getCancelBookingEntities = function (params, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.GET_CANCEL_BOOKING_ENTITIES, params); };
export var postCancelBookingForm = function (requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_CANCEL_BOOKING_FORM, requestData); };
export var postSuccessAction = function (requestData, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.POST_SUCCESS_ACTION, requestData); };
export var getCmsEntities = function (model_name, model_id, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.CMS, { model_name: model_name, model_id: model_id }); };
export var fetchUser = function (cancelToken) { return callAPI({ cancelToken: cancelToken, cacheParams: true, }, API_METHODS_ENUM.FETCH_USER); };
export var fetchUserEntities = function (entity, cancelToken) { return callAPI({ cancelToken: cancelToken, cacheParams: true, }, API_METHODS_ENUM.FETCH_USER_ENTITY, { entity: entity }); };
export var authenticateUser = function (arg, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.AUTHENTICATE_USER, arg); };
export var logoutUser = function (cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.LOGOUT); };
export var requestAuthLink = function (arg, cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.REQUEST_AUTHENTICATION_LINK, arg); };
export var refreshUserToken = function (cancelToken) { return callAPI({ cancelToken: cancelToken }, API_METHODS_ENUM.REFRESH_USER_TOKEN); };
var getTypedResponse = function (responseState, key) { return get(responseState, API_METHODS_ENUM.GET_INITIAL_ENTITIES) || {}; };
export var getInitialData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_INITIAL_ENTITIES) || {}; };
export var getBookDataPaginatedResponse = function (responseState) {
    return getBookDataPaginated(responseState).map(function (x) { return x.response; });
};
export var getBookData = function (responseState) {
    return get(responseState, API_METHODS_ENUM.GET_BOOK_ENTITIES);
};
export var getBookDataPaginated = function (responseState) {
    var _a;
    return [].concat((_a = get(responseState, getPaginatedRecordsPath(API_METHODS_ENUM.GET_BOOK_ENTITIES, true))) !== null && _a !== void 0 ? _a : {})
        .filter(function (x) { return x === null || x === void 0 ? void 0 : x.response; });
};
export var getCustomerData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_CUSTOMER_ENTITIES) || {}; };
export var getPaybookSession = function (responseState) { return get(responseState, API_METHODS_ENUM.POST_BOOKING_FORM) || {}; };
export var getPaybookData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_PAYBOOK_ENTITIES) || {}; };
export var getPaymentApprovedData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_PAYMENT_APPROVED) || {}; };
export var getPaymentCancelledData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_PAYMENT_CANCELLED) || {}; };
export var getBankTransferData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_BANK_TRANSFER_ENTITIES) || {}; };
export var getUserConsentsData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_USER_CONSENTS) || {}; };
export var getSepaDirectDebitData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_SEPA_ENTITIES) || {}; };
export var getOutgoingMessagesData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_OUTGOING_MESSAGES) || {}; };
export var getSuccessMessagesData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_SUCCESS_MESSAGES) || {}; };
export var getCancelBookingData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_CANCEL_BOOKING_ENTITIES) || {}; };
export var getCustomerListData = function (responseState) { return get(responseState, API_METHODS_ENUM.GET_CUSTOMER_LIST) || {}; };
export var getCmsEntitiesData = function (responseState) { return get(responseState, API_METHODS_ENUM.CMS) || {}; };
export var getUser = function (responseState) { return get(responseState, deriveMethodName(API_METHODS_ENUM.FETCH_USER, { cacheParams: true })) || {}; };
export var getUserEntity = function (responseState) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return get(responseState, deriveMethodName.apply(void 0, __spreadArray([API_METHODS_ENUM.FETCH_USER_ENTITY, { cacheParams: true }], args))) || {};
};
export var getAuthResponse = function (responseState) { return get(responseState, API_METHODS_ENUM.AUTHENTICATE_USER) || {}; };
export var getRefreshTokenResponse = function (responseState) { return getTypedResponse(responseState, API_METHODS_ENUM.REFRESH_USER_TOKEN); };
export var resetResponse = function (api, cacheParams) {
    var rest = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        rest[_i - 2] = arguments[_i];
    }
    return resetApiResponse(deriveMethodName.apply(void 0, __spreadArray([api, { cacheParams: cacheParams }], rest)));
};
export var resetUser = function () { return resetResponse(API_METHODS_ENUM.FETCH_USER, true); };
